import React from 'react';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '../../../../../constants';
import {
  InstagramPostsContextProvider,
  useInstagramPostsContext,
} from '@/features/marketplace/hooks/use-get-instagram-posts';

const FollowUsSectionContent = () => {
  const { instagramPosts } = useInstagramPostsContext();

  if (instagramPosts.length === 0) {
    return null;
  }

  return (
    <section className={clsx(
      'w-full bg-bg-primaryMedium',
      'pt-8',
      'pb-10'
    )}>
      {/* Title Section with centered content */}
      <div className={clsx(DEFAULT_CONTENT_WIDTH, 'm-auto')}>
        <div className={clsx(
          'flex flex-col items-start justify-center',
          'w-full',
          'mb-4 sm:mb-6'
        )}>
          <h2 className={clsx(
            'text-start font-bold text-text-primaryHeavy',
            'text-4xl md:text-5xl lg:text-6xl'
          )}>
            #colochousing
          </h2>
        </div>
      </div>

      {/* Scrollable Images Section - Full width*/}
      <div className={clsx(
        'scrollbar-hide flex overflow-x-auto',
        'gap-4',
        'pl-4 sm:pl-0',
        'sm:mx-auto sm:max-w-fit'
      )}>
        {instagramPosts.map((post) => (
          <a
            key={post.id}
            href={post.permalink}
            target="_blank"
            rel="noopener noreferrer"
            className={clsx(
              'group relative aspect-square flex-shrink-0 overflow-hidden rounded-[24px] bg-bg-primaryMedium',
              'w-[140px] sm:w-[226px] lg:w-[267px]'
            )}
          >
            <img
              src={post.media_url}
              alt={post.media_caption}
              className={clsx(
                'object-cover transition-transform duration-300 group-hover:scale-105',
                'h-full w-full'
              )}
            />
            <div className={clsx(
              'absolute inset-0 transition-opacity duration-300',
              'bg-black bg-opacity-0 group-hover:bg-opacity-10'
            )} />
          </a>
        ))}
      </div>
    </section>
  );
};

const FollowUsSection = () => {
  return (
    <InstagramPostsContextProvider>
      <FollowUsSectionContent />
    </InstagramPostsContextProvider>
  );
};

export { FollowUsSection };
